
const digest = '0c57f8dd75418039907c835030b5b1555cc3edb89b8fd857ce2dad0b0c7f4f36';
const css = `._selectionToolbar_gcpl6_1 {
  display: flex;
  position: absolute;
  transition: none !important; /* Disable popper transitions so toolbar doesn't zip around when changing selection. */

  background-color: var(--theme-primary-background);
  border: 1px solid var(--theme-primary-border);
  border-radius: var(--Common--border-radius);
  padding: 2px;

  --theme-editor-button-hovered: var(--aha-gray-200);
  transition: all 0.1s ease-out;
}

._selectionToolbarButton_gcpl6_15 {
  padding: var(--spacer-05, 2px);
}

._selectionToolbarRight_gcpl6_19 {
  flex-direction: column;
  padding: unset;
}

.aha-fullscreen ._selectionToolbarRight_gcpl6_19 {
  margin-left: -20px;
}

._selectionToolbarAbove_gcpl6_28 {
  flex-direction: row;
}

._selectionToolbar_gcpl6_1 aha-tooltip {
  --Tooltip__tooltip--font-size: 14px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"selectionToolbar":"_selectionToolbar_gcpl6_1","selectionToolbarButton":"_selectionToolbarButton_gcpl6_15","selectionToolbarRight":"_selectionToolbarRight_gcpl6_19","selectionToolbarAbove":"_selectionToolbarAbove_gcpl6_28"};
export { css, digest };
  